<template src="./index.html">
</template>

<script>
import {getdata} from './data.js'

export default {
  props: {
    invoiceDetailDiag: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: 0
    },
    invoiceId: {
      type: Number,
      default: -1
    },
  },
  data() {
    return {
      searchdiag: false,
      headData: getdata().headData,
      searchlist: getdata().searchlist,
      searchdata: getdata().searchdata,
      overlength: 0,
      tableData: [],
    }
  },
  created() {
  },
  methods: {
    findDate(id) {
      this.$message.info("findDate：" + id);
      this.tableData = [{mingxbh: 1, shangpmc: "test2"}];
    },
    closediag() {
      this.$emit("closeInvoiceDetailDiag");
    },
    closeSearch() {
      this.searchdiag = false;
    },
    saveChange(e) {
      this.searchdiag = false;
    },
    forUpdateSearch() {
      this.searchdiag = true;
    },
    submitSearch() {
      this.findDate(this.invoiceId);
    },
    geOoverLength(e) {
      this.overlength = e;
    },
  }

}
</script>

<style>
</style>